import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import { IColumn, ITagTypeMapInfo, ImportTypeEnum } from "../../services/data-file-import-data-service/Models";
import DataFileImportDataService from "../../services/data-file-import-data-service/DataFileImportDataService";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IeLynxObject } from "../../common/models/eLynxObject";

export type UseDataFileImportTagTypeMapParams = {
    groupID: number,
    fileHasHeaderRow: boolean,
    importObjectType: eLynxObjectTypeEnum,
    importType: ImportTypeEnum,
    tagTypeColumns: IColumn[],
    objects: IeLynxObject[] | undefined

} & BaseUseQueryParameters<ITagTypeMapInfo>;

export function useDataFileImportTagTypeMap({
    groupID,
    fileHasHeaderRow,
    importObjectType,
    importType,
    tagTypeColumns,
    objects,
    enabled,    
    onSuccess,
    onError
}: UseDataFileImportTagTypeMapParams) {
    return useQuery<ITagTypeMapInfo, RestError>(
        keys.tagTypeMap(groupID,
            fileHasHeaderRow,
            importObjectType,
            importType,
            tagTypeColumns,
            objects),
        ({ signal }) => {
            return DataFileImportDataService.configGetTagTypesMap(groupID, {
                importFileParams: {
                    fileHasHeaderRow,
                    importObjectType,
                    importType,
                    tagTypeColumns
                },
                tagTypesInUseOptions: {
                    dataType: importObjectType,
                    // For now overridden to true in the WebAPI
                    includeInternalTanks: true,
                    objects
                }},
            signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            // refetchInterval: false,
            // staleTime: Infinity,
            // refetchOnWindowFocus: false,
            // refetchOnMount: true,
            // refetchOnReconnect: false,
            // retry: false,
        }
    );
}